import { useReducer, createContext, useContext, useEffect } from "react";
import { BackendState, INITIAL_STATE, ACTION, ActionType } from "./backend-status-provider-types";
import { backendStatus } from "@/services/api/sessionApi";

const BackendContext = createContext<{ state: BackendState; dispatch: React.Dispatch<any> }>({
  state: INITIAL_STATE,
  dispatch: () => null,
});

function reducer(state: BackendState, action: ACTION): BackendState {
  switch (action.type) {
    case ActionType.SET_STATE:
      return { ...action.payload };
    default:
      return INITIAL_STATE;
  }
}
export const BackendStatusProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await backendStatus();
      if (!cancelled || data === false) {
        dispatch({
          type: ActionType.SET_STATE,
          payload: { online: false, featureFlags: INITIAL_STATE.featureFlags },
        });
      }
      dispatch({
        type: ActionType.SET_STATE,
        payload: { online: true, featureFlags: data },
      });
    })();
    return () => {
      // cleanup , maybe abort controllers
      cancelled = true;
    };
  }, []);

  return <BackendContext.Provider value={{ state, dispatch }}>{children}</BackendContext.Provider>;
};

export const useBackendContext = () => {
  const ctx = useContext(BackendContext);
  if (!ctx) throw new Error("useFeatureFlagContext must be used within BackendStatusProvider");
  return ctx;
};
